import React, { Component, Suspense } from "react";
import { withRouter } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { Card, CardBody } from "reactstrap";
import { Segment, Sidebar } from "semantic-ui-react";
import { connect } from "react-redux";
import Axios from "axios";
import { MentionsInput, Mention } from "react-mentions";
import ContentWrapper from "../../template/Layout/ContentWrapper";
// import InputEmoji from "react-input-emoji";
import Picker from "emoji-picker-react";
import { SampleData } from "./sampleData";
const TableFilterComponents = React.lazy(() => import("./TableFilters"));

const defaultStyle = {
  control: {
    backgroundColor: "#fff",
    fontSize: 14,
    fontWeight: "normal",
  },
  highlighter: {
    overflow: "hidden",
  },
  input: {
    margin: 0,
    overflow: "auto",
  },
  "&multiLine": {
    control: {
      fontFamily: "monospace",
      border: "1px solid silver",
    },
    highlighter: {
      padding: 9,
    },
    input: {
      padding: 9,
      minHeight: 3,
      outline: 0,
      border: 0,
    },
  },
  suggestions: {
    bottom: "0",
    top: "unset",
    list: {
      backgroundColor: "white",
      border: "1px solid rgba(0,0,0,0.15)",
      fontSize: 14,
    },
    item: {
      padding: "5px 15px",
      borderBottom: "1px solid rgba(0,0,0,0.15)",
      "&focused": {
        backgroundColor: "#cee4e5",
      },
    },
  },
};

const defaultMentionStyle = {
  backgroundColor: "#cee4e5",
};

const users = [
  {
    id: "walter",
    display: "@Walter White",
  },
  {
    id: "jesse",
    display: "@Jesse Pinkman",
  },
  {
    id: "gus",
    display: '@Gustavo "Gus" Fring',
  },
  {
    id: "saul",
    display: "@Saul Goodman",
  },
  {
    id: "hank",
    display: "@Hank Schrader",
  },
  {
    id: "skyler",
    display: "@Skyler White",
  },
  {
    id: "mike",
    display: "@Mike Ehrmantraut",
  },
  {
    id: "walter",
    display: "@Walter White",
  },
  {
    id: "walter",
    display: "@Walter White",
  },
  {
    id: "walter",
    display: "@Walter White",
  },
  {
    id: "walter",
    display: "@Walter White",
  },
  {
    id: "walter",
    display: "@Walter White",
  },
  {
    id: "walter",
    display: "@Walter White",
  },
  {
    id: "walter",
    display: "@Walter White",
  },
  {
    id: "walter",
    display: "@Walter White",
  },
  {
    id: "walter",
    display: "@Walter White",
  },
];

class Laboratory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: "",
      setText: "",
      value: "hello [@Walter White]{walter} there",
      mentions: [],
      dataTable: SampleData,
      columns:[
        { label: ' S. No', key: 'no' },
        { label: 'Project', key: 'project'},
        { label: 'Status', key: 'status' },
        { label: 'Desc', key: 'desc'},
        { label: 'Desc', key: 'desc'},
        { label: 'Desc', key: 'desc'},
        { label: 'Desc', key: 'desc'},
        { label: 'Desc', key: 'desc'},
        { label: 'Desc', key: 'desc'},
      ]
    };
    this.filterUpdated = this.filterUpdated.bind(this);
  }

  filterUpdated(newData) {
    this.setState({
      dataTable: newData,
    });
  }

  componentDidMount = () => {};

  handleChange = (event) => {
    const value = event.target.value;
    console.log("event: ", event.target.value);
    const regex = /[^{}]+(?=})/g;
    console.log("menregextions: ", regex);

    const mentions = value.match(regex);
    console.log("mentions: ", mentions);
    this.setState({ value: event.target.value });
  };

  onAdd = (id) => {
    console.log("added a new mention", id);
    this.setState({ mentions: [...this.state.mentions, id] });
  };

  handleOnEnter = (text) => {
    console.log("enter", text);
  };

  onEmojiClick = (event, emojiObject) => {
    console.log("emojiObject", emojiObject);
    // setChosenEmoji(emojiObject);
  };

  /*=============================================
  =            Render Method                    =
  =============================================*/

  render() {
    let { columns, data, searchOnInit, searchText, loadingInfo, dataTable} =
      this.state;

    return loadingInfo ? (
      ""
    ) : (
      <ContentWrapper>
        <div className="content-heading">
          {/* <Row> */}
          <legend className="legendEuro">
            <img
              style={{ margin: "-6px 6px 1px" }}
              alt=""
              src="https://magiclog.blob.core.windows.net/europartnerspic/Icono_administracion.svg"
              height="28"
              width="28"
            ></img>
            laboratorio
          </legend>
          {/* </Row> */}
        </div>
        <Card className="myCard">
          <CardBody id="mencionalble">
            <MentionsInput
              value={this.state.value}
              onChange={this.handleChange}
              style={defaultStyle}
              disable={true}
            >
              <Mention
                markup="[__display__]{__id__}"
                data={users}
                // onAdd={this.onAdd}
                style={defaultMentionStyle}
              />
            </MentionsInput>

            {/* <InputEmoji
              value={this.state.text}
              onChange={(text) => {
                console.log("hola", text);
                this.setState({
                  text,
                });
              }}
              cleanOnEnter
              onEnter={this.handleOnEnter}
              placeholder="Type a message"
            /> */}

            <Picker onEmojiClick={this.onEmojiClick} />
          </CardBody>
        </Card>
        <Card className="myCard">
          <div className="col-12">
              <Suspense fallback={<div>Loading...</div>}>
                <TableFilterComponents
                 dataTable={dataTable}
                 columns={columns}
                />
              </Suspense>
          </div>
        </Card>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Laboratory));
